<template>
  <v-dialog v-model="model" width="auto" scrollable>
    <v-card prepend-icon="mdi-information" title="Update Infos">
      <v-divider class="mt-3"></v-divider>

      <v-card-text class="px-8" style="height: 600px">
        <div class="changelog-content" v-html="Changelog.content.html"></div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="surface-variant"
          text="Schliessen"
          variant="flat"
          @click="model = false"
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script setup lang="ts">
import Changelog from '@/docs/Changelog.js'
const model = defineModel({ type: Boolean, required: true })
</script>
<style lang="scss">
.changelog-content ul {
  padding-left: 1.5rem; /* Add indentation for bullet points */
  margin-top: 0.5rem; /* Add spacing above the list */
}

.changelog-content li {
  margin-bottom: 0.5rem; /* Add spacing between list items */
}
</style>
